import React from 'react';
import {useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import {AccessControlProps} from 'modules/access-controls/types';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import citiesKeys from 'modules/cities/util/cities-keys';
import useCityAccessControls from 'modules/cities/hooks/use-city-access-controls';

const AccessControls: React.FC = () => {
  const {id} = useParams();
  const {data, isLoading} = useCityAccessControls(id!);

  return (
    <Table<AccessControlProps>
      loading={isLoading}
      data={
        data?.filter(
          (accessControl) => !accessControl.isDeliveryManAccessControl,
        ) ?? []
      }
      options={[
        'user.name',
        'permissionGroup.name',
        {
          value: 'id',
          label: 'Ações',
          column: (row) => (
            <QueryDeleteButton
              url={`/access-controls/${row.id}`}
              queryKey={citiesKeys.accessControls(id!)}
              type="update"
            />
          ),
        },
      ]}
      translatedPropsKey="AccessControlProps"
      onRowClick={() => null}
    />
  );
};

export default AccessControls;
